import { masterV2Api } from "@/apis/interceptor"
import { IBranchResponse, IResponse, IPaginationParamV2 } from "@/types"

export const branchesService = {
  getBranches: async (params: IPaginationParamV2): Promise<IResponse<IBranchResponse>> => {
    const response = await masterV2Api.get<IResponse<IBranchResponse>>("/v1/branches", { params })
    return response.data
  },
}
